const messages = {
  name: 'Backup / Restauracion',
  accessDenied: 'Solo un SuperUser puede acceder a la copia de seguridad y restauracion.',
  schedule: {
    title: 'Backup automatico',
    intro: 'Programa copias cifradas automaticas de la base de datos. El servidor las guarda en local, opcionalmente las sube a Google Drive y borra las mas antiguas segun la retencion. La passphrase de cifrado la configura el servidor.',
    introDrive: 'Programa copias cifradas automaticas de la base de datos. El servidor las guarda en local y las sube a Google Drive, y borra las mas antiguas segun la retencion. La passphrase de cifrado la configura el servidor.',
    enable: 'Activar backup automatico',
    intervalHours: 'Periodo (horas)',
    intervalHoursHint: 'Cada cuantas horas se hace una copia. 24 = diario.',
    dailyHourUtc: 'Hora del dia (UTC)',
    dailyHourUtcHint: 'Hora (0-23) de la primera copia del dia.',
    retention: 'Copias en el servidor',
    retentionHint: 'Las mas antiguas se borran. 0 = todas.',
    driveRetention: 'Copias en Drive',
    driveRetentionHint: 'Las mas antiguas se borran. 0 = todas.',
    driveDisabledHint: 'Drive no esta configurado en el servidor.',
    lastRun: 'Ultima copia',
    nextRun: 'Proxima copia',
    save: 'Guardar programacion',
    saving: 'Guardando...',
    saved: 'Programacion guardada',
    saveError: 'Error al guardar la programacion',
    loadError: 'No se pudo cargar la programacion',
    noPassphrase: 'El servidor no tiene passphrase de backup configurada: aunque actives la programacion, no se ejecutaran backups automaticos.',
  },
  backup: {
    title: 'Backup manual',
    hint: 'Descarga una copia cifrada de la base de datos ahora. Necesitaras esta misma passphrase para restaurarla; sin ella no hay forma de recuperar el contenido.',
    passphrase: 'Passphrase',
    passphraseHint: 'Minimo %{min} caracteres.',
    passphraseConfirm: 'Repite la passphrase',
    passphraseMismatch: 'Las passphrases no coinciden.',
    download: 'Descargar backup',
    downloading: 'Descargando...',
    started: 'Descarga de backup iniciada',
    error: 'No se pudo generar el backup',
  },
  restore: {
    title: 'Restaurar',
    warning: 'ATENCION: restaurar SOBREESCRIBE por completo la base de datos actual con el contenido del fichero. Los datos actuales se perderan de forma irreversible.',
    file: 'Fichero de backup (.rmtkbk)',
    passphrase: 'Passphrase del backup',
    restore: 'Restaurar',
    restoring: 'Restaurando...',
    ok: 'Base de datos restaurada correctamente',
    error: 'No se pudo restaurar el backup',
    confirmTitle: 'Restaurar base de datos?',
    confirmBody: 'Esta accion reemplaza TODA la base de datos actual con el contenido del backup. La operacion es destructiva e irreversible. Seguro que quieres continuar?',
  },
};

export default messages;
